import { render, staticRenderFns } from "./Evento_encuentro_live.vue?vue&type=template&id=621253b6&scoped=true&"
import script from "./Evento_encuentro_live.vue?vue&type=script&lang=js&"
export * from "./Evento_encuentro_live.vue?vue&type=script&lang=js&"
import style0 from "./Evento_encuentro_live.vue?vue&type=style&index=0&id=621253b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621253b6",
  null
  
)

export default component.exports